import Network from '@/services/network'

export default function handleOnlineAppointment() {
    const network = new Network;

    const fetchDepartments = (query) => {
        return network.api('get', '/online-appointment/doctors/departments' + query);
    };

    const fetchDoctorAppointmentInfo = (query) => {
        return network.api('get', '/online-appointment/doctors/appointment-info' + query);
    }

    const fetchCompanies = (query) => {
        return network.api('get', '/online-appointment/doctors/companies' + query);
    }

    const fetchServiceResources = (query) => {
        return network.api('get', '/online-appointment/doctors/service-resources' + query);
    }

    const fetchSingleResource = (id, query = '') => {
        return network.api('get', `/online-appointment/doctors/single-resource/${id}${query}`);
    }

    const fetchDoctorSchedule = (query = '') => {
        return network.api('get', `/online-appointment/doctors/doctor-appointment-schedule${query}`);
    }

    const verifyAppointment = (data) => {
        return network.api('post', '/online-appointment/doctors/verify-appointment', data);
    }

    const verifyRegisterPatient = (data) => {
        return network.api('post', '/online-appointment/doctors/verify-register-patient', data);
    }

    const signInPatient = (data) => {
        return network.api('post', '/online-appointment/doctors/signin-patient', data);
    }

    const loginPatient = (data) => {
        return network.api('post', '/online-appointment/doctors/login', data);
    }

    const resendOtp = (data) => {
        return network.api('post', '/online-appointment/doctors/resend-otp', data);
    }

    const fetchGenderList = () => {
        return network.api('get', '/online-appointment/doctors/gender-list');
    }

    return {
        fetchDepartments,
        fetchDoctorAppointmentInfo,
        fetchCompanies,
        fetchServiceResources,
        fetchSingleResource,
        fetchDoctorSchedule,
        verifyAppointment,
        verifyRegisterPatient,
        signInPatient,
        loginPatient,
        resendOtp,
        fetchGenderList
    };
}